import React, { Component } from "react";
import { connect } from "react-redux";
import debounce from "lodash/debounce";

// Components
import SearchbarInput from "../../utils/searchbar/SearchbarInput";
import ReviewSearchItem from "./ReviewSearchItem";
import ErrorText from "../../utils/error-success/ErrorText";

// State
import { getReviewSearchBySector } from "../../../store/actions/reviewSearch";
import { getSectorSuggestions } from "../../../store/actions/sectorSuggestions";

class ReviewSearch extends Component {
	constructor(props) {
		super(props);
		this.state = {
			q: "",
			canSearch: false,
			selectedIndex: 0,
			visible: false
		};
	}

	// ===================================
	//	LIFE CYCLE
	// ===================================
	componentDidMount() {
		document.addEventListener("mousedown", this.handleClickOutside);
	}

	componentWillUnmount() {
		document.removeEventListener("mousedown", this.handleClickOutside);
	}

	// ===================================
	//	INPUT HANDLING
	// ===================================
	setWrapperRef = node => {
		this.wrapperRef = node;
	};

	handleClickOutside = event => {
		if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
			this.setState({
				...this.state,
				visible: false
			});
		}
	};

	handleKeyPress = event => {
		if (event.key === "Enter") {
			event.preventDefault();

			// If the search dropdown is open, then search with the specific sector selected
			if (this.state.visible) {
				this.setState(
					{
						q: this.props.sectorSuggestions.results[this.state.selectedIndex].title
					},
					() => {
						this.handleItemClick(
							this.props.sectorSuggestions.results[this.state.selectedIndex],
							this.state.selectedIndex
						);
					}
				);
			}
			// Dropdown is closed, so perform a text-based search
			else {
				this.performReviewSearch();
			}
		}
	};

	handleKeyPressDebouncer = debounce(() => this.performSectorSuggestionSearch());

	handleKeyDown = event => {
		if (event.key === "ArrowDown") {
			this.arrowKeyDown();
		} else if (event.key === "ArrowUp") {
			this.arrowKeyUp();
		} else if (event.key === "Escape") {
			this.setState({
				visible: false
			});
		}
	};

	handleInputChange = event => {
		const { value } = event.target;
		this.setState(
			{
				...this.state,
				q: value
			},
			() => this.handleKeyPressDebouncer(value)
		);
	};

	// ===================================
	//	ARROWS
	// ===================================
	arrowKeyDown = () => {
		let { selectedIndex, visible } = this.state;

		// Only move item if list if visible
		if (visible) {
			selectedIndex +=
				this.props.sectorSuggestions.results.length - 1 > selectedIndex ? 1 : 0;
		}

		this.setState({
			visible: true,
			selectedIndex
		});
	};

	arrowKeyUp = () => {
		let { selectedIndex, visible } = this.state;

		// Only move item if list if visible
		if (visible) {
			selectedIndex -= selectedIndex > 0 ? 1 : 0;
		}

		this.setState({
			visible: true,
			selectedIndex
		});
	};

	// ===================================
	//	SPECIFIC ITEM CLICK
	// ===================================
	handleItemClick = (sector, i) => {
		this.setState(
			{
				q: this.props.sectorSuggestions.results[i].title,
				selectedIndex: i
			},
			() => {
				this.props.getReviewSearchBySector(null, sector.id, this.props.types);
			}
		);
	};

	// ===================================
	//	SEARCH
	// ===================================
	performSectorSuggestionSearch = () => {
		if (this.state.q === "") return;
		this.setState(
			{
				selectedIndex: 0
			},
			() =>
				this.props.getSectorSuggestions(this.state.q).then(res => {
					// Only show the suggestions if there are results
					this.setState({
						visible: res.data.data.results.length ? 1 : 0
					});
				})
		);
	};

	performReviewSearch = () => {
		this.props.getReviewSearchBySector(this.state.q, null, this.props.types);
	};

	// ===================================
	//	RENDER
	// ===================================
	render() {
		const { translations, sectorSuggestions, search } = this.props;

		return (
			<div className="reviews-search">
				{!!sectorSuggestions.error && <ErrorText errors={sectorSuggestions.error} />}
				{!!search.error && <ErrorText errors={search.error} />}
				<SearchbarInput
					placeholder={translations.sections.reviews.searchbar_placeholder}
					handleKeyPress={this.handleKeyPress}
					handleKeyDown={this.handleKeyDown}
					handleInputChange={this.handleInputChange}
					inProcess={sectorSuggestions.inProgress}
					q={this.state.q}
				/>
				<div className="ajax-search-content">
					{!!sectorSuggestions.results &&
					sectorSuggestions.results.length &&
					this.state.visible ? (
						<div className="search-dialog" ref={this.setWrapperRef}>
							<div className="tooltip-arrow" />
							<div className="content">
								{sectorSuggestions.results.map((item, i) => {
									return (
										<ReviewSearchItem
											key={i}
											item={item}
											isSelected={i === this.state.selectedIndex}
											handleClick={this.handleItemClick}
											index={i}
										/>
									);
								})}
							</div>
						</div>
					) : null}
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		translations: state.translations.translations,
		sectorSuggestions: state.sectorSuggestions,
		search: state.reviewSearch
	};
};

export default connect(
	mapStateToProps,
	{ getReviewSearchBySector, getSectorSuggestions }
)(ReviewSearch);



// WEBPACK FOOTER //
// ./src/components/reviews/review-search/ReviewSearch.js